export default __webpack_public_path__ + "static/media/2-4.7fae6343.png";